import React from 'react';

interface PlayArrowIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const PlayArrowIcon: React.FC<PlayArrowIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  className,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8 5v14l11-7z" fill={fill} />
  </svg>
);

export default PlayArrowIcon;
